// extracted by mini-css-extract-plugin
module.exports = {"tableColumns":"styles_tableColumns__2GRRr"};